import { customEmailConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { sendRemainderLoading: true, data: '', error: false };

export function sendRemainderReducer(state = initialState, action) {

    switch (action.type) {
        case customEmailConstants.REQUEST_SEND_REMAINDER:
            return {
                sendRemainderLoading: true,
                data: '',
                error: false
            };
        case customEmailConstants.RECIEVE_SEND_REMAINDER:
        swal({
            text: "Email sent Successfully!",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                sendRemainderLoading: false,
                data: action.sendRemainder,
                error: false
            };
        case customEmailConstants.ERROR_SEND_REMAINDER:
            return {
                sendRemainderLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/customEmails/sendRemainder.reducer.js